import { render } from "./TabWorkspace.vue?vue&type=template&id=58883592&scoped=true"
import script from "./TabWorkspace.vue?vue&type=script&lang=js"
export * from "./TabWorkspace.vue?vue&type=script&lang=js"

import "./TabWorkspace.vue?vue&type=style&index=0&id=58883592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58883592"]])

export default __exports__